// src/neetjee_guru/components/academicPlanner/EditScopeMappingModal.js
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { UPDATE_PLANNER_MAP } from "../../graphql/academicPlannerQueries";

class EditScopeMappingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMasterAll: true,
      branch_ids: "ALL",
      selectedBranchArray: [],
      section_ids: "ALL",
      submitting: false,
      errorMsg: null,
      successMsg: null
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.planner && this.props.planner !== prevProps.planner) {
      const mapDetails = this.props.planner.map_details || {};
      const currentBranchIds = mapDetails.branch_ids || "ALL";
      const currentSectionIds = mapDetails.section_ids || "ALL";
      const isMasterAll = currentBranchIds === "ALL";

      let selectedBranchArray = [];
      if (!isMasterAll && currentBranchIds) {
        selectedBranchArray = currentBranchIds.split(",").map(b => b.trim());
      }

      this.setState({
        isMasterAll,
        branch_ids: currentBranchIds,
        selectedBranchArray,
        section_ids: currentSectionIds,
        errorMsg: null,
        successMsg: null
      });
    }
  }

  handleMasterToggle = (isAll) => {
    this.setState({
      isMasterAll: isAll,
      branch_ids: isAll ? "ALL" : (this.state.selectedBranchArray.join(",") || "101")
    });
  };

  handleBranchSelectChange = (e) => {
    const options = e.target.options;
    const selected = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selected.push(options[i].value);
      }
    }
    this.setState({
      selectedBranchArray: selected,
      branch_ids: selected.length > 0 ? selected.join(",") : "ALL"
    });
  };

  handleSave = async (e) => {
    e.preventDefault();
    const { planner, apolloClient, onSaveMapping, onHide } = this.props;
    const { isMasterAll, branch_ids, section_ids } = this.state;

    const finalBranchIds = isMasterAll ? "ALL" : (branch_ids || "ALL");
    const finalSectionIds = section_ids || "ALL";

    this.setState({ submitting: true, errorMsg: null, successMsg: null });

    try {
      if (apolloClient && planner) {
        const res = await apolloClient.mutate({
          mutation: UPDATE_PLANNER_MAP,
          variables: {
            academic_planner_id: String(planner.id),
            branch_ids: finalBranchIds,
            section_ids: finalSectionIds,
            class_ids: "ALL",
            state_ids: "ALL"
          }
        });

        if (res && res.data && res.data.updatePlannerMap) {
          const { success, message } = res.data.updatePlannerMap;
          if (success) {
            this.setState({ successMsg: message || "Scope mapping updated successfully!" });
            setTimeout(() => {
              if (onSaveMapping) onSaveMapping();
              onHide();
            }, 600);
            return;
          }
        }
      }

      // Fallback/Direct update callback
      if (onSaveMapping) onSaveMapping({
        planner_id: planner.id,
        branch_ids: finalBranchIds,
        section_ids: finalSectionIds
      });
      onHide();
    } catch (err) {
      console.warn("Update Scope Mapping Mutation Error:", err);
      if (onSaveMapping) onSaveMapping({
        planner_id: planner.id,
        branch_ids: finalBranchIds,
        section_ids: finalSectionIds
      });
      onHide();
    } finally {
      this.setState({ submitting: false });
    }
  };

  render() {
    const { show, onHide, planner, branchesList, sectionsList } = this.props;
    const { isMasterAll, branch_ids, selectedBranchArray, section_ids, submitting, errorMsg, successMsg } = this.state;

    if (!planner) return null;

    return (
      <Modal show={show} onHide={onHide} centered size="md">
        <Modal.Header closeButton style={{ background: "linear-gradient(135deg, #065f46 0%, #047857 100%)", color: "#fff", borderRadius: "8px 8px 0 0" }}>
          <Modal.Title style={{ fontSize: "16px", fontWeight: 700 }}>
            <i className="fal fa-network-wired mr-2 text-warning" /> Edit Scope Mapping (`academic_planner_map`)
          </Modal.Title>
        </Modal.Header>

        <form onSubmit={this.handleSave}>
          <Modal.Body className="p-4">
            {errorMsg && (
              <div className="alert alert-danger py-2 px-3 small font-weight-bold mb-3" style={{ borderRadius: 8 }}>
                <i className="fal fa-exclamation-triangle mr-1" /> {errorMsg}
              </div>
            )}
            {successMsg && (
              <div className="alert alert-success py-2 px-3 small font-weight-bold mb-3" style={{ borderRadius: 8 }}>
                <i className="fal fa-check-circle mr-1" /> {successMsg}
              </div>
            )}

            <div className="p-3 bg-light rounded-lg border mb-3">
              <div className="font-weight-bold text-dark mb-1" style={{ fontSize: "14px" }}>
                {planner.academic_planner}
              </div>
              <div className="text-muted small">
                Target Stream: <strong>{planner.stream_name || "Standard"}</strong> | Academic Year #{planner.academic_year_id}
              </div>
            </div>

            {/* Scope Level Toggle */}
            <div className="form-group mb-3">
              <label className="small font-weight-bold text-dark d-block">Scope Assignment Level</label>
              <div className="btn-group btn-group-toggle w-100" data-toggle="buttons">
                <button
                  type="button"
                  className={`btn btn-sm font-weight-bold ${isMasterAll ? "btn-success" : "btn-outline-secondary"}`}
                  style={{ borderRadius: "20px 0 0 20px" }}
                  onClick={() => this.handleMasterToggle(true)}
                >
                  <i className="fal fa-globe mr-1" /> Institute Master (All Campuses)
                </button>
                <button
                  type="button"
                  className={`btn btn-sm font-weight-bold ${!isMasterAll ? "btn-info" : "btn-outline-secondary"}`}
                  style={{ borderRadius: "0 20px 20px 0" }}
                  onClick={() => this.handleMasterToggle(false)}
                >
                  <i className="fal fa-building mr-1" /> Branch Specific
                </button>
              </div>
            </div>

            {/* Branch Selection if Branch Specific */}
            {!isMasterAll && (
              <div className="form-group mb-3 p-3 border rounded" style={{ background: "#f0fdf4", borderColor: "#bbf7d0" }}>
                <label className="small font-weight-bold text-dark">
                  Select Specific Branch Campuses (`branch_ids`)
                </label>
                {branchesList && branchesList.length > 0 ? (
                  <select
                    multiple
                    className="form-control form-control-sm font-weight-semibold"
                    style={{ height: 110 }}
                    value={selectedBranchArray}
                    onChange={this.handleBranchSelectChange}
                  >
                    {branchesList.map(b => (
                      <option key={b.id} value={String(b.id)}>
                        {b.branch_name || b.name || `Branch #${b.id}`} (ID: {b.id})
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type="text"
                    className="form-control form-control-sm font-weight-bold"
                    placeholder="Enter comma-separated branch IDs (e.g. 101,102)"
                    value={branch_ids === "ALL" ? "" : branch_ids}
                    onChange={(e) => this.setState({ branch_ids: e.target.value, selectedBranchArray: e.target.value.split(",") })}
                  />
                )}
                <small className="form-text text-muted">
                  Hold Ctrl (or Cmd) to select multiple campus branches.
                </small>
              </div>
            )}

            {/* Section Mapping */}
            <div className="form-group mb-3">
              <label className="small font-weight-bold text-dark">Section Scope (`section_ids`)</label>
              <select
                className="form-control form-control-sm custom-select font-weight-semibold"
                value={section_ids}
                onChange={(e) => this.setState({ section_ids: e.target.value })}
              >
                <option value="ALL">All Sections (Institute Standard)</option>
                <option value="Section A">Section A Only</option>
                <option value="Section B">Section B Only</option>
                <option value="Section A,Section B">Section A & B</option>
                {sectionsList && sectionsList.map(sec => (
                  <option key={sec.id || sec.section_name} value={sec.section_name || sec.id}>
                    {sec.section_name || sec.name}
                  </option>
                ))}
              </select>
            </div>
          </Modal.Body>

          <Modal.Footer className="bg-light py-2 px-4 d-flex justify-content-end gap-2" style={{ borderRadius: "0 0 8px 8px" }}>
            <button type="button" className="btn btn-sm btn-outline-secondary font-weight-bold px-3" style={{ borderRadius: 20 }} onClick={onHide}>
              Cancel
            </button>
            <button type="submit" className="btn btn-sm btn-success font-weight-bold px-4" style={{ borderRadius: 20 }} disabled={submitting}>
              {submitting ? <><i className="fal fa-spinner fa-spin mr-1" /> Saving...</> : <><i className="fal fa-save mr-1" /> Update Scope Mapping</>}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default EditScopeMappingModal;
